import { ApiModelProperty } from '@nestjs/swagger/dist/decorators/api-model-property.decorator';

export class BazaNcInvestorAccountRegulationLimitsDto {
    @ApiModelProperty({
        description: 'Yearly income , cents',
        nullable: true,
    })
    yearlyIncomeCents: number;

    @ApiModelProperty({
        description: 'Net worth , cents',
        nullable: true,
    })
    netWorthCents: number;

    @ApiModelProperty({
        description: 'External RegCf Investments , Cents',
        nullable: true,
    })
    externalRegCfInvestmentsCents: number;

    @ApiModelProperty({
        description: 'Total account limits , cents',
        nullable: true,
    })
    accountTotalLimitCents: number;

    @ApiModelProperty({
        description: 'Current household income , cents',
        nullable: true,
    })
    currentHouseholdIncomeCents: number;

    @ApiModelProperty({
        description: 'The initial regCf limits which is calculated by networth and yearly income and external regCf investments ',
        nullable: true,
    })
    accountInitialRegCfLimits: number;
}
